define(["require", "exports", "noty"], function (require, exports, Noty) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var NovoNoty = (function () {
        function NovoNoty() {
        }
        NovoNoty.Show = function (text) {
            new Noty({
                text: text,
                type: 'success',
                theme: 'metroui',
                timeout: 2000
            }).show();
        };
        NovoNoty.ShowError = function (text) {
            new Noty({
                text: text,
                type: 'error',
                theme: 'metroui',
                timeout: 10000
            }).show();
        };
        NovoNoty.ShowErrorDetails = function (e) {
            var description = "";
            try {
                for (var key in e.xhr.responseJSON) {
                    if (typeof (e.xhr.responseJSON[key]) != "string" && e.xhr.responseJSON[key]["length"] != undefined) {
                        description += key + ":<br/>";
                        for (var key2 in e.xhr.responseJSON[key]) {
                            description += "&nbsp;&nbsp;" + e.xhr.responseJSON[key][key2] + "<br/>";
                        }
                    }
                    else
                        description += key + ": " + e.xhr.responseJSON[key] + "<br/>";
                }
            }
            catch (e) {
                console.log("error @ NovoNoty:" + e);
            }
            new Noty({
                text: "Der Befehl konnte nicht ausgef\u00FChrt werden. \n                <br/>Fehler: <br/>" + (description != "" ? description : e.errorThrown) + "\n                <br/>xhr-status:" + e.xhr.status + "\n                <br/>xhr-statusText:" + e.xhr.statusText,
                type: 'error',
                theme: 'metroui',
                timeout: 6000
            }).show();
        };
        return NovoNoty;
    }());
    exports.NovoNoty = NovoNoty;
});
//# sourceMappingURL=NovoNoty.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Shared/NovoNoty.js
// module id = 77
// module chunks = 0